import { NgModule } from '@angular/core';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginRouteGuard, NotLoginRouteGuard } from './route-guard';
import { MysqlService } from './services/mysql.service';
import { HttpClientModule } from '@angular/common/http';
import { AuthorizationService } from './services/authorization.service';
import { LoggerService } from './services/logger.service';
import { PreviewService } from './services/preview.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { FileService } from './services/file.service';
import { IonicStorageModule } from '@ionic/storage';
import { getEnv, getColor } from './shared';

import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { PartPickerModalComponent } from './components/part-picker-modal/part-picker-modal.component';
import { SharedModule } from './shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LibrettoComponent } from './components/Libretto/libretto.component';

//import { BackgroundMode } from '@ionic-native/background-mode/ngx';


let env = getEnv();


@NgModule({
  declarations: [AppComponent, PartPickerModalComponent,],
  entryComponents: [PartPickerModalComponent],
  imports: [
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    IonicStorageModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
 
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    LoginRouteGuard, NotLoginRouteGuard, MysqlService,
    AuthorizationService,
    LoggerService,
    PreviewService,
    LocalNotifications,
    ScreenOrientation,

    //BackgroundMode,
  ],
/**
 *     FormBuilder,
    WebIntent,
    FileChooser,
    FilePath,
    File,
    AppAvailability,
    InAppBrowser,
    DocumentViewer,
    Camera,],
 */



  bootstrap: [AppComponent]
})

export class AppModule {
}

